import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.257 11.25c.002-1.086.001-1.885-.002-2.36a1.5 1.5 0 0 0 .995-1.412V5.632a2.5 2.5 0 0 0-2.402-2.498A193 193 0 0 0 12.34 3q-4.111 0-7.686.137A2.5 2.5 0 0 0 2.25 5.635v1.847c.003.65.417 1.202.995 1.409-.004.474-.004 1.274-.002 2.36l.003 1.136.003.995.001.609q0 1.976.094 3.465a3.5 3.5 0 0 0 3.204 3.268Q9.885 21 12.275 21q2.385 0 5.678-.274a3.5 3.5 0 0 0 3.203-3.268q.094-1.49.094-3.467l.001-.607.003-.995zM16.25 8.982h4.006a363 363 0 0 1-.002 3.404l-.003.996-.001.609q0 1.949-.092 3.404a2.5 2.5 0 0 1-2.288 2.334q-3.256.27-5.595.271-2.347 0-5.644-.273a2.5 2.5 0 0 1-2.29-2.334 55 55 0 0 1-.091-3.402l-.001-.611-.003-.996-.003-1.135a353 353 0 0 1 .001-2.267zM4.693 4.136a1.5 1.5 0 0 0-1.443 1.5V7.48a.5.5 0 0 0 .502.498 622 622 0 0 1 6.83-.005c.574.006 2.79.006 3.355 0q1.63-.015 6.813.005a.5.5 0 0 0 .5-.5V5.632a1.5 1.5 0 0 0-1.441-1.499A192 192 0 0 0 12.34 4q-4.093 0-7.647.136m4.883 9.958a.338.338 0 0 1-.477-.478l2.442-2.435a1.18 1.18 0 0 1 1.67 0l2.44 2.442a.338.338 0 0 1-.477.478l-2.44-2.442-.052-.045v6.022a.307.307 0 1 1-.614 0v-6.021l-.05.043z",
      clipRule: "evenodd"
    }
  )
);
var SvgUnarchiveOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var UnarchiveOutlined_default = SvgUnarchiveOutlined;

export { UnarchiveOutlined_default as default };
